import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import VueScrollTo from "vue-scrollto";
import auth from "../ui/Auth/routes";
import dashboard from "../ui/Dashboard/routes";
import pages from "../ui/Pages/routes";
import store from "../store";

const routes = [...dashboard, ...auth, ...pages];

const router = createRouter({
    base: "/",
    history: createWebHistory("/"),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            VueScrollTo.scrollTo("#app", 500, { offset: savedPosition.y });
            return savedPosition;
        } else {
            VueScrollTo.scrollTo("#app");
        }
    },
});
const isAuthenticated = () =>  !!_.get(store, 'state.auth.token',"");
router.beforeEach((to, from, next) => {
    if (to.name !== "auth.login" && !isAuthenticated()) {
        return next({ name: "auth.login" });
    }else{
        return next();
    }
});
router.beforeResolve((to, from, next) => {
    if (to.name) {
        // Запустить отображение загрузки
        NProgress.start();
    }
    next();
});

router.afterEach(() => {
    // Завершить отображение загрузки
    NProgress.done();
});
export default router;
